import React from 'react';
import StatusBubbles from '../StatusBubbles';
import styled from 'styled-components';

function StatusBubblesContainer(props) {
  const { tags, overdue, scheduled } = props;
  const firstTag = tags[0];
  const remainingCount = tags.length - 1;
  const allClasses = [...new Set(tags.map((t) => t.tooltipTitle).filter(Boolean))];
  const allTooltip = allClasses.length > 0
    ? allClasses.reduce((acc, line, i) => (i === 0 ? [line] : [...acc, <br key={i} />, line]), [])
    : null;
  const displayTag = firstTag
    ? {
        ...firstTag,
        name: remainingCount > 0 ? `${firstTag.name} +${remainingCount} more` : firstTag.name,
        tooltipTitle: allTooltip,
      }
    : null;
  return (
    <StatusBubblesInternalContainer>
      <TagShrinkWrapper>
        {displayTag && (
          <StatusBubbles
            key="tag-0"
            tag={displayTag}
            overdue={overdue}
            scheduled={scheduled}
          />
        )}
      </TagShrinkWrapper>
      {overdue && <OverDueTab>Overdue</OverDueTab>}
      {scheduled && (
        <ScheduledTab>
          <TooltipLink href="" target="_blank" rel="noopener noreferrer">
            {scheduled.text}
            <span className="tooltip-text">{scheduled.tooltip}</span>
          </TooltipLink>
        </ScheduledTab>
      )}
    </StatusBubblesInternalContainer>
  );
}

const TooltipLink = styled.a`
  position: relative;
  text-decoration: underline;
  color: inherit;
  cursor: pointer;

  .tooltip-text {
    visibility: hidden;
    opacity: 0;
    width: max-content;
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    text-align: center;
    padding: 4px 8px;
    border-radius: 4px;
    position: absolute;
    bottom: 120%;
    left: 50%;
    transform: translateX(-50%);
    transition: opacity 0.2s ease-in-out;
    white-space: nowrap;
    z-index: 10;
    font-size: 12px;
  }

  &:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
  }
`;

const TagShrinkWrapper = styled.div`
  min-width: 0;
  flex: 1 1 0%;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

const StatusBubblesInternalContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  position: relative;
  min-width: 0;
  width: 100%;
  overflow: hidden;
`;

const ScheduledTab = styled.div`
  background: linear-gradient(90deg, #8e44ad 2.99%, #9b59b6 100%);
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: rgba(255, 255, 255, 1);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 3px 8px;
`;

const OverDueTab = styled.div`
  background: linear-gradient(90deg, #de2b2b 2.99%, #de4c2b 100%);
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: rgba(255, 255, 255, 1);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 3px 8px;
`;

export default StatusBubblesContainer;
